import request from '@/utils/request'

//获取报警管理列表
export function GetAlarmList(data){
    return request({
        url: '/car/alarm/data',
        method: 'post',
        data
    })
}

// 获取类型下拉框
export function GetTypeList() {
    return request({
        url: '/car/alarm/alarmType',
        method: 'post'
    })
  }

//更改报警状态
export function UpdateStatus(data){
    return request({
        url: '/car/alarm/confirm',
        method: 'post',
        data
    })
}